import Button from '@atlaskit/button';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalTitle,
    ModalFooter,
    ModalTransition,
} from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives';

interface InstallationDetailsModalProps {
    isOpen: boolean;
    onReinstall: () => void;
    onManageSiteDetails: () => void;
}

export const InstallationDetailsModal = ({ 
    isOpen, 
    onReinstall, 
    onManageSiteDetails 
}: InstallationDetailsModalProps) => {
    return (
        <ModalTransition>
            {isOpen && (
                <Modal onClose={onManageSiteDetails}>
                    <ModalHeader>
                        <ModalTitle>{"You've already installed the Rovo App"}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <Box>
                            <p>Continue with the setup process and add your site details, or reinstall the app.</p>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Box style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'flex-end'
                        }}>
                            <Button appearance="primary" onClick={onManageSiteDetails}>
                                Continue setup
                            </Button>
                            <Button appearance="warning" onClick={onReinstall}>
                                Reinstall
                            </Button>
                        </Box>
                    </ModalFooter>
                </Modal>
            )}
        </ModalTransition>
    );
};
